import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HSEProvider } from "./lib/store";
import { AuthProvider } from "./lib/auth";
import RequireAuth from "./components/RequireAuth";
import AppLayout from "./components/layout/AppLayout";
import Login from "./pages/Login";
import ExecutiveDashboard from "./pages/ExecutiveDashboard";
import MonthlyKPI from "./pages/MonthlyKPI";
import Incidents from "./pages/Incidents";
import Inspections from "./pages/Inspections";
import ActionPlan from "./pages/ActionPlan";
import PermitToWork from "./pages/PermitToWork";
import Training from "./pages/Training";
import Observations from "./pages/Observations";
import NCRRegister from "./pages/NCRRegister";
import Audits from "./pages/Audits";
import Waste from "./pages/Waste";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/*" element={
              <RequireAuth>
                <HSEProvider>
                  <AppLayout>
                    <Routes>
                      <Route path="/" element={<ExecutiveDashboard />} />
                      <Route path="/monthly-kpi" element={<MonthlyKPI />} />
                      <Route path="/incidents" element={<Incidents />} />
                      <Route path="/inspections" element={<Inspections />} />
                      <Route path="/action-plan" element={<ActionPlan />} />
                      <Route path="/permit-to-work" element={<PermitToWork />} />
                      <Route path="/training" element={<Training />} />
                      <Route path="/observations" element={<Observations />} />
                      <Route path="/ncr-register" element={<NCRRegister />} />
                      <Route path="/audits" element={<Audits />} />
                      <Route path="/waste" element={<Waste />} />
                      <Route path="/reports" element={<Reports />} />
                      <Route path="/settings" element={<Settings />} />
                    </Routes>
                  </AppLayout>
                </HSEProvider>
              </RequireAuth>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
